import { render, staticRenderFns } from "./SubirPlanilhaClientes.vue?vue&type=template&id=5d033a32"
import script from "./SubirPlanilhaClientes.vue?vue&type=script&lang=js"
export * from "./SubirPlanilhaClientes.vue?vue&type=script&lang=js"
import style0 from "./SubirPlanilhaClientes.vue?vue&type=style&index=0&id=5d033a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports